import ProfileDetailsSection from './ProfileDetailsSection';

export default ProfileDetailsSection;
